import React from "react";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header/Header";

const PrivacyPolicy = () => {
  return (
    <div
      className="hero heros blogs privacy"
      style={{
        height: "auto !important ",
        background: " linear-gradient(61deg, #070707 50.84%, #222 96.86%)",
      }}
    >
      <div className="px-3 py-3 px-xxl-4 py-xxl-4">
        <Header />

        <h1 className="text-center gradient-text  mt-5 mb- 5">
          Privacy Policy
        </h1>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <p>
              Cosmic Network LLC, registered as a business in Meydan FZ Dubai,
              are dedicated to safeguarding your privacy and protecting your
              personal information. This Privacy Policy details how we collect,
              use, and protect your data when you use our VPN App.
            </p>
            <div className="mb-3">
              <h4>Information We Collect</h4>
              <label htmlFor="">Usage Data:</label>
              <ul>
                <li>
                  We gather information regarding your interactions with our
                  app.
                </li>
              </ul>
            </div>
            <div className="mb-3">
              <h4>How we use your information</h4>
              <label htmlFor="">
                The information we collect may be utilized for the following
                purposes:
              </label>
              <ul>
                <li>
                  To deliver and support the functionality and services of our
                  app.
                </li>{" "}
                <li>To communicate with you and address your inquiries.</li>
                <li>
                  To identify and prevent fraudulent activities, ensuring the
                  app's security.
                </li>
              </ul>
            </div>
            <div className="mb-3">
              <h4>Data Sharing and Disclosure</h4>
              <p>
                Your information may be shared with third-party service
                providers to support the app's functionality. However, we do not
                sell or rent your personal information to third parties for
                marketing purposes
              </p>
            </div>{" "}
            <div className="mb-3">
              <h4>Data Retention</h4>
              <p>
                Your personal information is retained only as long as necessary
                to fulfill the purposes outlined in this Privacy Policy or as
                required by law. We will securely delete or anonymize your
                information when it is no longer needed.
              </p>
            </div>{" "}
            <div className="mb-3">
              <h4>Changes to This Privacy Policy</h4>
              <p>
                We reserve the right to revise or modify this Privacy Policy at
                any time. We will inform you of any changes by posting the
                updated Privacy Policy on this page. Continuing to use the app
                after changes are made signifies your acceptance of the revised
                Privacy Policy.
              </p>
            </div>{" "}
            <div className="mb-3">
              <h4>Contact Us</h4>
              <p>
                If you have questions or concerns about our Privacy Policy or
                our app's privacy practices, please contact us at {" "}
                <a className="mail" href="" mailto="">team@cosmicnetwork.io</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
